module.exports = __webpack_public_path__ + "static/media/IMG_20191128_144850.d6b3176b.jpg";